import { render, staticRenderFns } from "./KernelSubstrateEditor.vue?vue&type=template&id=32a062c7&"
import script from "./KernelSubstrateEditor.vue?vue&type=script&lang=js&"
export * from "./KernelSubstrateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports